<script>
    import { onMount } from 'svelte';
    import { strip_tags } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/sanitize.js?1733898724673';

    export let headline;    
    export let open = false;

    let container;

    onMount(() => {
        function handleClickOutside(event) {
            if (container && !container.contains(event.target) && open) {
                open = false;
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
</script>

<div bind:this={container} class="container">
    <button class="headline {open ? 'open' : ''}"  on:click={() => (open = !open)} type="button">{@html strip_tags(headline)}</button>
    <div class="content {open ? 'open' : ''}">
        <slot />
    </div>
</div>


<style>div .headline {
    border: 1px solid #040b1c;
    width: 100%;
    display: block;
    line-height: 28px;
    text-transform: uppercase;
    position: relative;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    padding: 5px 40px 5px 10px;
}
div .headline:before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='12' viewBox='0 0 22 12'%3E%3Cpath d='M21.82,1.11l-1-.94a.6.6,0,0,0-.84,0L11,8.73,2,.17a.6.6,0,0,0-.84,0l-1,.94a.53.53,0,0,0,0,.8l10.4,9.92a.6.6,0,0,0,.84,0l10.4-9.92A.53.53,0,0,0,21.82,1.11Z' transform='translate(0 0)' fill='%23040b1c'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 14px;
    -webkit-transition: -webkit-transform 0.5s ease-in-out;
    transition: -webkit-transform 0.5s ease-in-out;
    transition: transform 0.5s ease-in-out;
    transition: transform 0.5s ease-in-out, -webkit-transform 0.5s ease-in-out;

    content: '';
    pointer-events: none;
    position: absolute;
    top: 7px;
    right: 8px;
    width: 25px;
    height: 25px;
}
div .headline:after {
    border: 1px solid var(--darkblue);
    content: '';
    pointer-events: none;
    position: absolute;
    top: 7px;
    right: 8px;
    width: 25px;
    height: 25px;
}
div {
    width: 100%;
}

    .container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
    }

    .headline {
        width: max-content;
        background-color: transparent;
        text-align: left;
    }
    .headline.open:before{
        transform: rotate(180deg);
    }

    .content {
        position: absolute;
        background-color: #FBF0D1;
        z-index: -1;
        pointer-events: all;
        margin-top: 5px;
        width: 100%;
        max-height: 90vh;
        overflow: auto;
        overflow-x: hidden !important;
        top: 110%;
        opacity: 0; /* Start mit einer Opazität von 0, um es unsichtbar zu machen */
        transform: translateY(0); /* Startposition für die Transition */
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out; /* Füge eine Transition für Opazität und Transform hinzu */
        max-height: 90vh;
        padding: 20px;
    }

    /* Füge eine Klasse hinzu, um die Opazität auf 1 zu setzen und die Position zu ändern, wenn der Inhalt geöffnet wird */
    .content.open {
        opacity: 1;
        z-index: 2000;
        transform: translateY(-5px); /* Du kannst den Wert anpassen, um die endgültige Position anzupassen */
    }

    .content :global(input[type="checkbox"]){
        width: 20px;
        height: 20px;
        border: 1px solid #303133;
    }
</style>